module.exports = __webpack_public_path__ + "static/img/icon_email.806dc197.png";